const persistkeys = {
  THEME: 'THEME',
  LANG: 'LANG',
  accessToken: 'accessToken',
  alert: 'ALERT',
  FCM: 'FCM',
};

enum routesName {
  LOGIN = 'login',
  FORGETPASSWORD = 'forgetPassword',
  CONVERSATIONS = 'conversations',
  CONTACT = 'contact',
  CHAT = 'chat',
  PROFILE = 'profile',
  PROFILECONTACT = 'profileContact',
  HOME = 'home',
}

export { persistkeys, routesName };
